import { useState, useEffect } from "react";
import axios from "axios";
import { API, getMemberHeaders } from "../utils/api";

const OFFER_INFO = {
  bundle: {
    title: "NBC Startup Bundle",
    subtitle: "$175 Total Value",
    price: "$99.99 + 8% tax",
    cta: "Get the Startup Bundle — $99.99",
    items: ["Boxing Gloves ($29.99)", "Hand Wraps ($9.99)", "NBC Shirt ($24.99)", "30-Min Personal Lesson ($30.00)", "1 Month Elite Unlimited ($79.99)"],
  },
  gloves_wraps: {
    title: "Boxing Gloves + Hand Wraps",
    subtitle: "$39.98 combined value — ~15% off",
    price: "$33.99 + 8% tax",
    cta: "Get Gloves + Wraps — $33.99",
    items: ["Boxing Gloves ($29.99)", "Hand Wraps ($9.99)"],
  },
  hand_wraps: {
    title: "NBC Hand Wraps",
    subtitle: "$9.99 regular price",
    price: "$8.99 + 8% tax",
    cta: "Get Hand Wraps — $8.99",
    items: ["NBC Hand Wraps"],
  },
};

export default function MerchCheckoutPage() {
  const params    = new URLSearchParams(window.location.search);
  const product   = params.get("p") || params.get("product") || "bundle";
  const memberId  = params.get("m") || params.get("member") || "";
  const offer     = OFFER_INFO[product] || OFFER_INFO.bundle;
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState("");
  const [purchased, setPurchased] = useState(false);

  useEffect(() => {
    // Check if already purchased
    if (!memberId) return;
    axios.get(`${API}/merch/status/${memberId}`, getMemberHeaders())
      .then(r => { if (r.data.purchased) setPurchased(true); })
      .catch(() => {});
  }, [memberId]);

  const handleCheckout = async () => {
    if (!memberId) { setError("Missing member ID. Please use the link from your text message."); return; }
    setLoading(true); setError("");
    try {
      const res = await axios.post(`${API}/merch/checkout`, {
        product, member_id: memberId,
        origin_url: window.location.origin,
      }, getMemberHeaders());
      window.location.href = res.data.url;
    } catch (e) {
      setError(e.response?.data?.detail || "Could not start checkout. Please try again.");
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#0A0A0A", display: "flex", alignItems: "center", justifyContent: "center", padding: 20, fontFamily: "'Poppins', -apple-system, sans-serif" }}>
      <div style={{ background: "#111", border: "1.5px solid #FFB612", borderRadius: 16, maxWidth: 400, width: "100%", padding: "28px 20px" }}>
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <img src="/nbc_logo.jpg" alt="NBC" style={{ width: 56, height: 56, borderRadius: 8, objectFit: "contain", marginBottom: 10 }} />
          <h1 style={{ fontSize: 20, fontWeight: 900, color: "#FFB612", margin: "0 0 6px", fontFamily: "inherit", textTransform: "none", letterSpacing: "normal" }}>
            {offer.title}
          </h1>
          <p style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", margin: 0 }}>{offer.subtitle}</p>
        </div>

        {purchased ? (
          <div style={{ background: "rgba(34,197,94,0.1)", border: "1px solid rgba(34,197,94,0.3)", borderRadius: 10, padding: 16, textAlign: "center" }}>
            <p style={{ color: "#22C55E", fontWeight: 800, fontSize: 15, margin: 0 }}>✅ You've already purchased this offer!</p>
            <p style={{ color: "rgba(255,255,255,0.5)", fontSize: 12, marginTop: 6 }}>Your order will be ready at the front desk.</p>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: 16 }}>
              {offer.items.map((item) => (
                <div key={item} style={{ fontSize: 13, color: "rgba(255,255,255,0.7)", marginBottom: 4 }}>• {item}</div>
              ))}
            </div>
            <div style={{ fontSize: 22, fontWeight: 900, color: "#FFB612", marginBottom: 4 }}>
              {offer.price}
            </div>
            {error && (
              <div style={{ background: "rgba(239,68,68,0.1)", border: "1px solid rgba(239,68,68,0.3)", borderRadius: 8, padding: 10, fontSize: 12, color: "#F87171", marginBottom: 12 }}>
                {error}
              </div>
            )}
            <button
              onClick={handleCheckout}
              disabled={loading}
              style={{
                width: "100%", background: loading ? "rgba(255,182,18,0.4)" : "#FFB612",
                color: "#000", border: "none", borderRadius: 10,
                padding: "14px 0", fontSize: 15, fontWeight: 900,
                cursor: loading ? "default" : "pointer", letterSpacing: 0.3,
              }}
            >
              {loading ? "Loading…" : offer.cta}
            </button>
            <p style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", textAlign: "center", marginTop: 10 }}>
              Secure checkout via Stripe. First-visit members only.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
